import React from 'react';
import { BaseIcon } from 'components';

export const SearchIcon = (props) => {
  return(
    <BaseIcon props={props} className={`search-icon ${props.className || ''}`}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
        <path fill="#000000" fillRule="evenodd" d="M15.0049 17.5143c-1.5405 1.0545-3.4043 1.6714-5.41206 1.6714C4.29486 19.1857 0 14.8908 0 9.59284 0 4.29486 4.29486 0 9.59284 0c5.29796 0 9.59286 4.29486 9.59286 9.59284 0 2.51476-.9677 4.80346-2.5509 6.51416L24 23.4722l-1.5186 1.5186-7.4765-7.4765zm2.0331-7.92146c0 4.11186-3.3333 7.44516-7.44516 7.44516s-7.44519-3.3333-7.44519-7.44516 3.33333-7.44519 7.44519-7.44519S17.038 5.48098 17.038 9.59284z" clipRule="evenodd"/>
      </svg>
    </BaseIcon>
  )
};
